"use strict";
import {http} from '../../core';
const RequestService = http.create();

function serviceList(params) { // 服务列表
    return RequestService.get('service/list', params)
}

export {
    serviceList
}